import { createSelector } from 'reselect';
import { getEntitySelector } from '../selectors';
import { ENTITIES_KEY_FONT } from './index';

export const getFontEntities = (state) => getEntitySelector(state, ENTITIES_KEY_FONT);

export const getFonts = createSelector(getFontEntities, (fontEntities) => {
    if (!fontEntities) {
        return [];
    }
    const { allIds = [], ...fonts } = fontEntities;
    return allIds.map((fontId) => fonts[fontId]);
});
